import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'datepicker';
import 'bsfilestyle';
require('datatables.net');
require('datatablesResponsive');
require('parsley');
import { bookingFormCommon } from "./c005-bookingform-common";
import { loginForm } from "./c005-login";
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";
import 'MagnificPopup';

import * as numeral from 'numeral';

var rangeslider = require('rangeslider');
var Nanobar     = require('nanobar');

export class memberPortal {
	private $memberHeader:any = $('.members__nav');
	private $memberContent:any = $('.members__content');
	private bookingformcommon = new bookingFormCommon();
	private loginForm = new loginForm();
	private adobeDataLayer = new adobeDataLayerWrapper();
	private enrichvoucherpartnername:any;
	
	getParameterByName():any {

		let _self = this;
		let defer = $.Deferred();
		
		if ((window.location.href.indexOf('enrich-summary.html') > 0) && !(window.location.origin.indexOf('author') > 0))
		{
			/*var redirectUrl = window.location.href;
			if (window.location.hash && window.location.hash == '#_=_') {
				redirectUrl = window.location.href.split('#')[0];
			}
			else if(redirectUrl.slice(-1)=='#')
			{
				redirectUrl = redirectUrl.slice(0, -1);
			}
			console.log("redirectUrl--"+redirectUrl);
		let urlParams = _self.bookingformcommon.getUrlVars(redirectUrl);*/		
		let loggedIn = _self.loginForm.isUserLoggedIn();
		if (!loggedIn) {
			let cookieAccessToken = _self.getCookie("sapphire");
			if (cookieAccessToken)
			{
				if(cookieAccessToken!=="undefined")
				{
					_self.bookingformcommon.preloader();				
					var decodedToken = parseJwt(cookieAccessToken);
					console.log(decodedToken);
		
					desktopValidation(decodedToken,cookieAccessToken).done((res:any) => {
						if(res=="OK")
						{
							defer.resolve("OK");					
						}
						else
						{
							defer.reject(res);					
						}
					});
					
				}
				else{
					let $invalidAccessTokenUrl: any	=	$('#invalidAccessTokenUrl');
					if (($invalidAccessTokenUrl.val()!='null')  && ($invalidAccessTokenUrl.val()!='')) {
						window.location.href= $invalidAccessTokenUrl.val();
					}
					defer.resolve("OK");
				}
				
			}
			else{
				let $azureEnrichLoginUrl: any	=	$('#azureEnrichLoginUrl');
				if (($azureEnrichLoginUrl.val()!='null')  && ($azureEnrichLoginUrl.val()!='')) {
					window.location.href= $azureEnrichLoginUrl.val();
				}
				defer.resolve("OK");
			}
	
		}
		else{
			defer.resolve("OK");
		}	
	}
	else if (window.location.href.indexOf('register-temp-card.html') > 0)
	{		
		let cookieAccessToken = _self.getCookie("sapphire");
		$("#enterEnrichPortalBtn").on('click', function() {
			let cookieAccessToken1 = _self.getCookie("sapphire");
			document.cookie = "sapphire="+cookieAccessToken1+";domain=.malaysiaairlines.com;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
			document.cookie = "tempCard=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		});
		$("#enterExplorerPortalBtn").on('click', function() {
			let cookieAccessToken2 = _self.getCookie("sapphire");
			document.cookie = "sapphire="+cookieAccessToken2+";domain=.malaysiaairlines.com;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
			document.cookie = "tempCard=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		});

		if (cookieAccessToken)
		{
			var decodedToken = parseJwt(cookieAccessToken);
			_self.bookingformcommon.preloader();			
			getUserName(decodedToken,cookieAccessToken).done((res:any) => {
				if(res=="OK")
				{
					defer.resolve("OK");					
				}
				else
				{
					defer.reject(res);					
				}
			});
			
		}

	}
	else if (window.location.href.indexOf('mhexplorer-home.html') > 0)
	{	
		$("#mhexplorerLoginCTABtn").on('click', function() {
			let cookieAccessToken = _self.getCookie("sapphire");	
			document.cookie = "sapphire="+cookieAccessToken+";domain=.malaysiaairlines.com;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
			document.cookie = "tempCard=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		});
		defer.resolve("OK");
	}
	else{
		defer.resolve("OK");
	}		
		
		return defer.promise();
		
		function parseJwt (token:any): any {
			var base64Url = token.split('.')[1];
			var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		
			return JSON.parse(base64);
		};
		function getUserName(decodedToken:any,accessToken:any){
			let defer = $.Deferred();
			console.log('Success');
			$.ajax({
				type: 'POST',
				url:'/bin/services/new/azuregetuserdetails',
				success: function(msg:string) {
					//_self.redirectUser(msg);
					//_self.$loginErrorValidation.show();
					var json = JSON.parse(msg);
					var fullname = json.firstName + " " + json.lastName;
					var details = {
						"name": fullname,
						"flyerId": decodedToken.extension_flyerid,
						"membershipStatus": ""
					};
					document.cookie = "tempCard=" + JSON.stringify(details) + ";path=/";
					_self.bookingformcommon.preloaderClose();
					defer.resolve("OK");
				},
				error: function(error:any) {
					console.log('Fail submit');
					_self.bookingformcommon.preloaderClose();
					// _self.$ibeFormContainer.hide();
					defer.reject(error);
				}
			});	
			
			return defer.promise();
		}
		function desktopValidation(decodedToken:any,accessToken:any){
			
			let defer = $.Deferred();
			console.log('Success');
			 	var data = {
					'loyaltyToken':	decodedToken.extension_loyaltyToken,
					'enrichId': decodedToken.extension_flyerid
				};
			
					$.ajax({
							type: 'POST',
							url:'/bin/services/new/azureauthuser',
							data: data,
							success: function(msg:string) {
							//_self.redirectUser(msg);
							//_self.$loginErrorValidation.show();
							var json = JSON.parse(msg);
							var responseCode = json.responseCode;
							if (responseCode == "OK") {
								console.log("success");
								//var loginSuccess = $("#exceptionmsg").attr("data-loginsuccess");
			
								var d = new Date();
								d.setTime(d.getTime() + (30 * 60 * 1000));
								var expires = "expires="+d.toUTCString();
								
								//document.cookie="accessToken="+accessToken+";"+expires+";path=/";
								//document.cookie="jade="+json.cookieValue+";"+expires+";path=/";
								document.cookie="phantom="+json.phantomCookieValue+";"+expires+";path=/";
								document.cookie = "userName=" + JSON.parse(json.phantomCookieValue).userName +";"+expires+";path=/";
								document.cookie = "milesCount=" + JSON.parse(json.phantomCookieValue).milesCount + ";"+expires+";path=/";
								document.cookie = "flyerID=" + JSON.parse(json.phantomCookieValue).flyerID + ";"+expires+";path=/"; 
								document.cookie = "memberStatus=" + JSON.parse(json.phantomCookieValue).memberStatus + ";"+expires+";path=/";
								 _self.bookingformcommon.preloaderClose();
								//window.location.href = loginSuccess;
								window.location.reload();
								defer.resolve("OK");
			
							  // Redirect to the configured page from here.
						  } 
						  
						},
						error: function(error:any) {
							console.log('Fail submit');
							_self.bookingformcommon.preloaderClose();
							// _self.$ibeFormContainer.hide();
							defer.reject(error);
						}
					  });	
					  
					  return defer.promise();
				}

	}

	

	/**
	 * [mobileNavbarClickHandler description]
	 * @return {any} [description]
	 */
	mobileNavbarClickHandler():any {
		let prevWinWidth:number = window.innerWidth;
		let _self     = this;
		let sidebar   = _self.$memberHeader.find('#enrich-nav-sidebar');
		let toggleBtn = _self.$memberHeader.find('#enrich-nav-toggle-btn');

		function resizeEndFunctions(){

			if (window.innerWidth < 1200 && prevWinWidth >= 1200) {
				// collapse menu in mobile view
				toggleBtn.addClass('collapsed');
				toggleBtn.attr('aria-expanded', 'false');

				sidebar.removeClass('in')
				sidebar.attr('aria-expanded', 'false');
			} else if (window.innerWidth >= 1200 && prevWinWidth < 1200) {
				// expand menu in desktop view
				toggleBtn.removeClass('collapsed');
				toggleBtn.attr('aria-expanded', 'true');

				sidebar.addClass('in')
				sidebar.attr('aria-expanded', 'true');
			}

			prevWinWidth = window.innerWidth;

		}

		let doWindowResizeStuff:any;

		window.onresize = function(){
			clearTimeout(doWindowResizeStuff);
			doWindowResizeStuff = setTimeout(resizeEndFunctions, 300);
		};
	}

	/**
	 * [mobileNavInit description]
	 * @return {any} [description]
	 */
	mobileNavInit(): any {
		let winWidth:number = window.innerWidth;
		let _self     = this;
		let sidebar   = _self.$memberHeader.find('#enrich-nav-sidebar');
		let toggleBtn = _self.$memberHeader.find('#enrich-nav-toggle-btn');

		if (winWidth <= 1200) {
			// collapse menu in mobile view
			toggleBtn.addClass('collapsed');
			toggleBtn.attr('aria-expanded', 'false');

			sidebar.removeClass('in')
			sidebar.attr('aria-expanded', 'false');
		}
	}

	/**
	 * MESU-292
	 * set content min-height when toggling navbar
	 * - due to absolute positioning of navbar, expanding all the navbar menu items
	 *   causes a double scroll bar on the page
	 */
	handleNavbarCollapse(): void {
		let _self       = this;
		let sidebar     = _self.$memberHeader.find('#enrich-nav-sidebar');
		let mainContent = _self.$memberContent;
		let mainContentHeight = mainContent.outerHeight();

		sidebar.find('.collapse').each(function(){
			$(this).on('shown.bs.collapse hidden.bs.collapse', function(){
				let newSidebarHeight:number = getSidebarHeight();

				if (mainContentHeight < newSidebarHeight) {
					mainContent.animate({
						'min-height': newSidebarHeight
					});
				} else {
					mainContent.animate({
					'min-height': mainContentHeight
					});
				}
			});

		});

		function getSidebarHeight():number {
			return sidebar.outerHeight();
		}
	}

	/**
	 * [stringifyMemberNavMilesValue description]
	 * format member miles number to pretty string using
	 * numeral.js
	 *
	 * - running on the assumption number in element DOES NOT
	 *   contain alpha chars
	 * @return {any} [description]
	 */
	stringifyMemberNavMilesValue(): any {
		let _self = this;
		let navMilesEl = _self.$memberHeader.find('.member-nav--miles-info .miles-value');
		let navMilesVal = navMilesEl.text();

		return navMilesEl.text(numeral(navMilesVal).format('0,0'));

	}

	/**
	 * [setMemberContainerMinHeight description]
	 * @return {any} [description]
	 */
	setMemberContainerMinHeight(): any {
		let _self = this;
		let sidebar:any = _self.$memberHeader.find('.sidebar-menu');
		let mainContent:any = _self.$memberContent;

		// calculate sidebar height
		let sidebarHeight:number = sidebar.height();

		// set min height to main content to display full sidebar
		mainContent.css('min-height', sidebarHeight);
	}

	/**
	 * initialize all form inputs[text] with focus and filled effects
	 * @param  {any} inputElArr [description]
	 * @return {any}            [description]
	 */
	initFormTextInputs(inputElArr:any): any {
		for (var i=0, len=inputElArr.length; i<len; i++) {
			if (!inputElArr[i].classList.contains('datepicker')) { // exclude datepicker input fields
				$(inputElArr[i])
				.on('focus', function(e:any){
					let $this:any = $(this);
					$this.addClass('input-focused').removeClass('has-error');
					$this.parent().addClass('input-focused');
					$this.parent().find('label').addClass('input-filled').removeClass('has-error');
				})
				.on('blur', function(e:any){
					let $this:any = $(this);
					if ($this.val() == '') {
						$this.removeClass('input-focused');
						$this.parent().removeClass('input-focused');
						$this.parent().find('label').removeClass('input-filled');
					}
					else {
						$this.addClass('input-focused');
						$this.parent().find('label').addClass('input-filled');
					}
				});
			}
		}
	}

	/**
	 * Init selectize elements
	 * @param  {any} inputSelectArr [description]
	 * @return {any}                [description]
	 */
	initSelectizeInputs(inputSelectArr:any): any {
		for (var i=0, len=inputSelectArr.length; i<len; i++) {
			let isUpdateProfilebookingtitle:boolean = false;
			if (inputSelectArr[i].classList.contains('update-profile--title')||inputSelectArr[i].classList.contains('update-profile--gender')) {
				isUpdateProfilebookingtitle = true;
			}
			if (!inputSelectArr[i].classList.contains('countrycode-input') && !inputSelectArr[i].classList.contains('ibe-from--location') 
			&& !inputSelectArr[i].classList.contains('ibe-to--location') && !inputSelectArr[i].classList.contains('ibe-mob-from--location') 
			&& !inputSelectArr[i].classList.contains('ibe-mob-to--location')&& !inputSelectArr[i].classList.contains('cabin-class-mob') && !inputSelectArr[i].classList.contains('cabin-class') ) {
				let $this:any      = $(inputSelectArr[i]);
				let $thisLabel:any = $this.parent().find('label');
				$this.selectize({
					valueField: 'value',
					labelField: 'text',
					searchField: ['text'],
					selectOnTab: true,
					onInitialize: () => {
						$this[0].selectize.$control_input.attr('name', $this[0].selectize.$input[0].id.split('--')[1]);
						$this[0].selectize.$control_input.attr('data-parsley-errors-container', '#' + $this[0].selectize.$input[0].id + '--error-container');
					},
					onFocus: () =>  {
						$thisLabel.addClass('input-filled');
						$($this[0].selectize.$control[0]).addClass('select-filled');
					},
					onChange: () => {
						$thisLabel.addClass('input-filled');
						$($this[0].selectize.$control[0]).addClass('select-filled');
				// 		$('.update-profile--personal-prefcountries').change(function () {
				// 			var dataList = JSON.parse(localStorage['lcp-search']); 
				// 			var selectize = $("#update-profile--personal-prefstates")[0].selectize;
				// 			selectize.clear();
				// 			selectize.clearOptions();

				// 				for(var i = 0; i < dataList.CountriesList.length; i++)
				// 				{
				// 						if(dataList.CountriesList[i].CountryCode == $('#update-profile--personal-prefcountries').val())
				// 						{
				// 						$.each(dataList.CountriesList[i].StatesList, function (index:any, value:any) 
				// 						{
				// 							$("#update-profile--personal-prefstates").each(function() {
				// 								if (this.selectize) {
				// 									this.selectize.addOption({value:value.StateCode, text: value.StateName});
				// 								}
				// 							});

				// 						});
				// 					}
				// 				}
				// 		});
				// 		$('.update-profile--personal-countries').change(function () {
						
				// 			var dataList = JSON.parse(localStorage['lcp-search']); 
				// 			if(!$('#lcp_update_profile_members').hasClass("data-population"))
				// 			{
				// 				var selectize = $("#update-profile--personal-states")[0].selectize;
				// 				selectize.clear();
				// 				selectize.clearOptions();
				// 			}
				// 				for(var i = 0; i < dataList.CountriesList.length; i++)
				// 				{
				// 						if(dataList.CountriesList[i].CountryCode == $('#update-profile--personal-countries').val())
				// 						{
				// 						$.each(dataList.CountriesList[i].StatesList, function (index:any, value:any) 
				// 						{
				// 							$("#update-profile--personal-states").each(function() {
				// 								if (this.selectize) {
				// 									this.selectize.addOption({value:value.StateCode, text: value.StateName});
				// 								}
				// 							});

				// 						});
				// 					}
				// 				}
				// 	});
				// 	$('.update-profile--personal-address-country').change(function () {
						
				// 		var dataList = JSON.parse(localStorage['lcp-search']); 
				// 		if(!$('#lcp_update_profile_members').hasClass("data-population"))
				// 		{
				// 			var selectize = $("#update-profile--personal-states")[0].selectize;
				// 			selectize.clear();
				// 			selectize.clearOptions();
				// 		}
				// 			for(var i = 0; i < dataList.CountriesList.length; i++)
				// 			{
				// 					if(dataList.CountriesList[i].CountryCode == $('#update-profile--personal-address-country').val())
				// 					{
				// 					$.each(dataList.CountriesList[i].StatesList, function (index:any, value:any) 
				// 					{
				// 						$("#update-profile--personal-states").each(function() {
				// 							if (this.selectize) {
				// 								this.selectize.addOption({value:value.StateCode, text: value.StateName});
				// 							}
				// 						});

				// 					});
				// 				}
				// 			}
				// });
						$(".addtravellerairline").change(function () {
						let airline = this.parentElement.children[0].children[0].children[1].children[0].innerText;
						let airlinecode =this.parentElement.children[1].children[0].children[1].id;
						let hiddenairlinecode=this.parentElement.children[2].children[1].id;
						if(airline=="")
						{
							$(('#'+airlinecode)).val('');
						}
						switch(airline)
						{
						case 'American Airlines' :$(('#'+airlinecode)).val('AA');
						$(('#'+hiddenairlinecode)).val('AA')
						break;
						case 'British Airways' :$(('#'+airlinecode)).val('BA');	
						$(('#'+hiddenairlinecode)).val('BA')
						break;
						case 'Cathay Dragon' :$(('#'+airlinecode)).val('KA');
						$(('#'+hiddenairlinecode)).val('KA')
						break;
						case 'Cathay Pacific' :$(('#'+airlinecode)).val('CX');
						$(('#'+hiddenairlinecode)).val('CX')	
						break;
						case 'Emirates' :$(('#'+airlinecode)).val('EK');
						$(('#'+hiddenairlinecode)).val('EK')	
						break;
						case 'Etihad Airways' :$(('#'+airlinecode)).val('EY');
						$(('#'+hiddenairlinecode)).val('EY')	
						break;
						case 'Finnair' :$(('#'+airlinecode)).val('AY');
						$(('#'+hiddenairlinecode)).val('AY')
						break;
						case 'Iberia' :$(('#'+airlinecode)).val('IB');
						$(('#'+hiddenairlinecode)).val('IB')	
						break;
						case 'Japan Airlines' :$(('#'+airlinecode)).val('JL');
						$(('#'+hiddenairlinecode)).val('JL')
						break;
						case 'KLM Royal Dutch Airlines' :$(('#'+airlinecode)).val('KL');
						$(('#'+hiddenairlinecode)).val('KL')	
						break;
						case 'LATAM Airlines Group' :$(('#'+airlinecode)).val('LA');
						$(('#'+hiddenairlinecode)).val('LA')	
						break;
						case 'Malaysia Airlines' :$(('#'+airlinecode)).val('MH');
						$(('#'+hiddenairlinecode)).val('MH')
						break;
						case 'Qantas Airways' :$(('#'+airlinecode)).val('QF');
						$(('#'+hiddenairlinecode)).val('QF')	
						break;
						case 'Qatar Airways' :$(('#'+airlinecode)).val('QR');
						$(('#'+hiddenairlinecode)).val('QR')	
						break;
						case 'Royal Jordanian' :$(('#'+airlinecode)).val('RJ');
						$(('#'+hiddenairlinecode)).val('RJ')
						break;
						case 'Siberia Airlines' :$(('#'+airlinecode)).val('S7');
						$(('#'+hiddenairlinecode)).val('S7')	
						break;
						case 'Singapore Airlines' :$(('#'+airlinecode)).val('SQ');
						$(('#'+hiddenairlinecode)).val('SQ')	
						break;
						case 'SriLankan Airlines' :$(('#'+airlinecode)).val('UL');
						$(('#'+hiddenairlinecode)).val('UL')	
						break;
					}
					});
						if (isUpdateProfilebookingtitle) {
							let $titleselect: any = $('#update-profile--title');
							let $genderselect: any = $('#update-profile--gender');
							let $bookingtitleinput: any = $('#update-profile--booktitle');
							let $titleselectvalue = $titleselect.val();
							let $genderselectvalue = $genderselect.val();
							if ($genderselectvalue !== '' && $titleselectvalue !== '') {
								if ($genderselectvalue === 'M') {
									$bookingtitleinput.val('Mr');
								} else if ($genderselectvalue === 'F') {									
										if ($titleselectvalue !== 'Mrs') {
											$bookingtitleinput.val('Miss');
										}									
								}
							}
						
						if ($titleselectvalue !== '') {
							if ($titleselectvalue === 'Mrs') {
								$bookingtitleinput.val('Mrs');
							}
						}
					}
					},
					onBlur: () => {
						let $activeOptionChange:any = $this[0].selectize.getValue();
						
						if ($activeOptionChange == null || !$activeOptionChange.length) {
							$thisLabel.removeClass('input-filled');
							$($this[0].selectize.$control[0]).removeClass('select-filled');
						} else {
							$thisLabel.addClass('input-filled');
							$($this[0].selectize.$control[0]).addClass('select-filled');
						}
					},
				});
			}
		}
	}

	/**
	 * [initDatepickerInputs description]
	 * @param  {any}     inputElArr    [description]
	 * @param  {Date}    minDate       [description]
	 * @param  {Date}    maxDate       [description]
	 * @param  {boolean} beforeShowDay [description]
	 * @param  {any}     beforeShowFn  [description]
	 * @return {any}                   [description]
	 */
	initDatepickerInputs(
		inputElArr:any,
		minDate:Date,
		maxDate:Date,
		beforeShowDay:boolean,
		beforeShowFn:any): any {
		for (var i=0, len=inputElArr.length; i<len; i++) {
			let $this:any      = $(inputElArr[i]);
			let $thisLabel:any = $this.parent().find('label');

			let params:any = {
				showButtonPanel: true ,
				closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
				dateFormat: 'd M yy',
				numberOfMonths: 1,
				changeMonth: true,
				changeYear: true,
				yearRange: "-90:+90",
				onSelect : function(dateText:string, instance:any) {
					$this.parent().addClass('input-focused');
					$this.addClass('input-focused').removeClass('has-error');
					$thisLabel.addClass('input-filled').removeClass('has-error');
				}
			};

			if (minDate !== undefined) {
				params['minDate'] = minDate;
			}

			if (maxDate !== undefined) {
				params['maxDate'] = maxDate;
			}

			if (beforeShowDay !== undefined) {
				params['beforeShowDay'] = beforeShowDay;
			}

			if (beforeShowFn !== undefined) {
				params['beforeShowFn'] = beforeShowFn;
			}

			$(inputElArr[i]).attr('readonly', 'readonly');
			$(inputElArr[i]).datepicker(params);
		}
	}

	/**
	 * [initPhoneInput description]
	 * @param  {any} inputElArr [description]
	 * @return {any}            [description]
	 */
	initPhoneInput(inputElArr:any):any {
		for (var i=0, len=inputElArr.length; i<len; i++) {
			let $this:any = inputElArr[i];
			let $cunCodeInput:any = $(inputElArr[i]).find('.phoneinput__countrycode select');
			let $cunCodeLabel:any = $(inputElArr[i]).find('.phoneinput__countrycode label');
			let $phoneLabel:any   = $(inputElArr[i]).find('.phoneinput__phonenumber label');
			let $phoneInput:any   = $(inputElArr[i]).find('.phoneinput__phonenumber input');

			// init country code field
			$cunCodeInput.selectize({
				valueField: 'text',
				labelField: 'text',
				searchField: ['text'],
				selectOnTab: true,
				onInitialize: () => {
					$cunCodeInput[0].selectize.$control_input.attr('name', $cunCodeInput[0].selectize.$input[0].id.split('--')[1]);
					$cunCodeInput[0].selectize.$control_input.attr('data-parsley-errors-container', '#' + $cunCodeInput[0].selectize.$input[0].id + '--error-container');
				},
				onFocus: () =>  {
					$cunCodeLabel.addClass('input-filled');
					$($cunCodeInput[0].selectize.$control[0]).addClass('select-filled');
				},
				onChange: () =>  {
					$cunCodeLabel.addClass('input-filled');
					$($cunCodeInput[0].selectize.$control[0]).addClass('select-filled');
				},
				onBlur: () => {
					let $activeOptionChange:any = $cunCodeInput[0].selectize.getValue();
					if ($activeOptionChange == null || !$activeOptionChange.length) {
						$cunCodeLabel.removeClass('input-filled');
						$($cunCodeInput[0].selectize.$control[0]).removeClass('select-filled');
					} else {
						$cunCodeLabel.addClass('input-filled');
						$($cunCodeInput[0].selectize.$control[0]).addClass('select-filled');
					}
				},
			});

			// init phone number field
			$phoneInput
			.on('focus', function(e:any){
				let $this:any = $(this);
				$this.addClass('input-focused').removeClass('has-error');
				$this.parent().addClass('input-focused');
				$phoneLabel.addClass('input-filled').removeClass('has-error');
			})
			.on('blur', function(e:any){
				let $this:any = $(this);
				if ($this.val() == '') {
					$this.removeClass('input-focused');
					$this.parent().removeClass('input-focused');
					$phoneLabel.removeClass('input-filled');
				}
				else {
					$this.addClass('input-focused');
					$phoneLabel.addClass('input-filled');
				}
			});
		}
	}

	/**
	 * [initRangeInput description]
	 * @param {any} inputElArr [description]
	 */
	initRangeInput(inputElArr:any) {
		for (var i=0, len=inputElArr.length; i<len; i++) {
			let $this:any = inputElArr[i];
			let $thisId:string = $this.id;
			let $thisInputId:string = $thisId.replace(/-slider/g,'');
			let $thisInput:any = $($this).parents().eq(2).find('#'+$thisInputId);
			let $thisInputLabel:any = $($thisInput).parent().find('label');

			// set input field to readonly
			$thisInput.attr('readonly', 'readonly');

			$($this).rangeslider({
				polyfill: false,

				// Callback function
				onInit: function() {},

				// Callback function
				onSlide: function(position:any, value:any) {
					$thisInputLabel.addClass('input-filled');
					$thisInput.addClass('input-focused input-filled');
					$thisInput.val(value);
					$thisInput.trigger('change'); // trigger change event
				},

				// Callback function
				onSlideEnd: function(position:any, value:any) {
				}
			});
		}
	}

	/**
	 * [initProgressBarElem description]
	 * @param {any} inputElArr [description]
	 */
	initProgressBarElem(inputElArr:any) {
		for (var i=0, len=inputElArr.length; i<len; i++) {
			let $this:any = inputElArr[i];
			let $thisClass:string = $this.classList[0];
			let $thisId:string = ($this.id).toString();
			let $value:number = $this.getAttribute('value');
			let $maxVal:number = $this.getAttribute('max');
			let $percVal:number = $value/$maxVal * 100;

			// remove hidden from classList
			$thisClass = $thisClass.replace(/hidden/g,'');

			// create progress display container
			$($this).after('<div class="progress-item--container" id="' + $thisId + '-progress-container"></div>');
			let $thisContainer:any = $($this).parent().find('#'+$thisId+'-progress-container')[0];

			let options = {
				classname: $thisClass,
				id: $thisId,
				target: $thisContainer
			};

			let nanobar = new Nanobar( options );

			nanobar.go($value/$maxVal * 100);			
			// $('.miles-sectors-earned').css('width', ($value/$maxVal * 100) +'%');
		}
	}

	initCircularProgressBarElem() {
		let DEFAULTS:any = {
			backgroundColor: '#b3cef6',
			progressColor: '#4b86db',
			percent: 0,
			duration: 2000,
			milestype: '',
			milespoints:'0',
			milestotal:'0'
		};	
		
		$('.progress-bar.position').each(function () {
			let $target:any  = $('.progress-bar.position');

			let opts:any = {
			backgroundColor: $target.data('color') ? $target.data('color').split(',')[0] : DEFAULTS.backgroundColor,
			progressColor: $target.data('color') ? $target.data('color').split(',')[1] : DEFAULTS.progressColor,
			percent: $target.data('percent') ? $target.data('percent') : DEFAULTS.percent,
			duration: $target.data('duration') ? $target.data('duration') : DEFAULTS.duration,
			milestype: $target.data('milestype') ? $target.data('milestype') : DEFAULTS.milestype,
			milespoints:$target.data('milespoints') ? $target.data('milespoints') : DEFAULTS.milespoints,
			milestotal:$target.data('milestotal') ? $target.data('milestotal') : DEFAULTS.milestotal,			
			};
			// console.log(opts);
	
			// $target.append('<div class="background"></div><div class="rotate"></div><div class="left"></div><div class="right"></div><div class=""><span>' + opts.percent + '</span></div>');
			$target.append('<div class="background"></div><div class="rotate"></div><div class="left"></div><div class="right"></div><div class=""><span><p class ="miles-name">'+ opts.milestype +'</p><p class ="miles-points">' + opts.milespoints +'</p><p class ="miles-total">of '+ opts.milestotal +'</p></span></div>');
	
			$target.find('.background').css('background', opts.backgroundColor);
			$target.find('.left').css('background-color', opts.backgroundColor);
			$target.find('.rotate').css('background-color', opts.progressColor);
			$target.find('.right').css('background-color', opts.progressColor);
	
			let $rotate:any = $target.find('.rotate');
			setTimeout(function () {	
				$rotate.css({
					'transition': 'transform ' + opts.duration + 'ms linear',
					'transform': 'rotate(' + opts.percent * 3.6 + 'deg)'
				});
			},1);		

			if (opts.percent > 50) {
				let animationRight:any = 'toggle ' + (opts.duration / opts.percent * 50) + 'ms step-end';
				let animationLeft:any = 'toggle ' + (opts.duration / opts.percent * 50) + 'ms step-start';  
				$target.find('.right').css({
					animation: animationRight,
					opacity: 1
				});
				$target.find('.left').css({
					animation: animationLeft,
					opacity: 0
				});
			} 
		});
	}

	initCircularProgressBarElemlcp() {
		let DEFAULTS:any = {
			backgroundColor: '#b3cef6',
			progressColor: '#4b86db',
			percent: 0,
			duration: 2000,
			milestype: '',
			milespoints:'0',
			milestotal:'0'
		};	
		
		$('.progress-bar.position').each(function () {
			let $target:any  = $('.progress-bar.position');

			let opts:any = {
			backgroundColor: $target.data('color') ? $target.data('color').split(',')[0] : DEFAULTS.backgroundColor,
			progressColor: $target.data('color') ? $target.data('color').split(',')[1] : DEFAULTS.progressColor,
			percent: $target.data('percent') ? $target.data('percent') : DEFAULTS.percent,
			duration: $target.data('duration') ? $target.data('duration') : DEFAULTS.duration,
			milestype: $target.data('milestype') ? $target.data('milestype') : DEFAULTS.milestype,
			milespoints:$target.data('milespoints') ? $target.data('milespoints') : DEFAULTS.milespoints,
			milestotal:$target.data('milestotal') ? $target.data('milestotal') : DEFAULTS.milestotal,			
			};
			// console.log(opts);
	
			// $target.append('<div class="background"></div><div class="rotate"></div><div class="left"></div><div class="right"></div><div class=""><span>' + opts.percent + '</span></div>');
			$target.append('<div class="background"></div><div class="rotate"></div><div class="left"></div><div class="right"></div><div class=""><span><p class ="miles-points">' + opts.milespoints +'</p></span></div>');
	
			$target.find('.background').css('background', opts.backgroundColor);
			$target.find('.left').css('background-color', opts.backgroundColor);
			$target.find('.rotate').css('background-color', opts.progressColor);
			$target.find('.right').css('background-color', opts.progressColor);
	
			let $rotate:any = $target.find('.rotate');
			setTimeout(function () {	
				$rotate.css({
					'transition': 'transform ' + opts.duration + 'ms linear',
					'transform': 'rotate(' + opts.percent * 3.6 + 'deg)'
				});
			},1);		

			if (opts.percent > 50) {
				let animationRight:any = 'toggle ' + (opts.duration / opts.percent * 50) + 'ms step-end';
				let animationLeft:any = 'toggle ' + (opts.duration / opts.percent * 50) + 'ms step-start';  
				$target.find('.right').css({
					animation: animationRight,
					opacity: 1
				});
				$target.find('.left').css({
					animation: animationLeft,
					opacity: 0
				});
			} 
		});
	}
	/**
	 * [initTables description]
	 * @return {any} [description]
	 */
	initTables(tableEl:any, pagingVal:boolean): any {
		if (!tableEl.length) { return false; }

		let paging:boolean = false;

		if (pagingVal == undefined) {
			paging = false;
		} else {
			paging = pagingVal;
		}

		tableEl.attr('data-slideout-ignore','');
		let dsearchable:boolean = tableEl[0].dataset.searchable !== undefined ? (tableEl[0].dataset.searchable === 'true') : true;
		let dpaging:boolean = tableEl[0].dataset.paging !== undefined ? (tableEl[0].dataset.paging === 'true') : paging;
		tableEl.DataTable({
			responsive: true,
			paging: dpaging,
			info: false,
			searching: dsearchable,
			dom: 'frtipl',
			columnDefs: [ {
				"targets"  : 'no-sort',
				"orderable": false,
			}]
		});
	}

	/**
	 * [initIncrementer description]
	 * @param  {any} inputElArr [description]
	 * @return {any}            [description]
	 */
	initIncrementer(inputElArr:any): any {
		for (var i=0, len=inputElArr.length; i<len; i++) {
			let el = $(inputElArr[i]);
			let btnMinus       = el.find('.incrementer__btn.incrementer--decrement');
			let btnPlus        = el.find('.incrementer__btn.incrementer--increment');
			let elDisplay      = el.find('.incrementer__display');
			let input          = el.find('input[type="hidden"]');
			let curVal:number = 0;
			let	params = {
				'min': parseInt(el[0].dataset.min),
				'max': parseInt(el[0].dataset.max),
				'initvalue': parseInt(el[0].dataset.initValue)
			};


			// btnMinus click handler
			// - on click, increment display value & input[hidden] value
			btnMinus.on('click', function(e:any) {
				e.preventDefault();
				e.stopPropagation();

				if ("vibrate" in navigator) {
					// vibration API supported
					navigator.vibrate(25);
				}

				curVal = setIncrementer(elDisplay, input, curVal, params, 'decrement');
			});

			// btnMinus click hold handler
			// - on hold down click,
			//   automatically decrement by 1 unit per 100ms
			//   until mouseout
			let btnMinInterval:any;

			btnMinus.on('mousedown', function(e:any) {
				e.preventDefault();
				e.stopPropagation();

				btnMinInterval = setInterval(function() {
					curVal = setIncrementer(elDisplay, input, curVal, params, 'decrement');
				}, 200);
			}).on('mouseup mouseleave', function() {
				clearInterval(btnMinInterval);
			});

			// btnPlus click handler
			// - on click, increment display value & input[hidden] value
			btnPlus.on('click', function(e:any) {
				e.preventDefault();
				e.stopPropagation();

				if ("vibrate" in navigator) {
					// vibration API supported
					navigator.vibrate(35);
				}

				curVal = setIncrementer(elDisplay, input, curVal, params, 'increment');
			});

			// btnPlus click hold handler
			// - on hold down click,
			//   automatically decrement by 1 unit per 100ms
			//   until mouseout
			let btnPlusInterval:any;

			btnPlus.on('mousedown', function(e:any) {
				e.preventDefault();
				e.stopPropagation();

				// set initial delay (500ms)
				btnPlusInterval = setInterval(function() {
					curVal = setIncrementer(elDisplay, input, curVal, params, 'increment');
				}, 200);
			}).on('mouseup mouseleave', function() {
				clearInterval(btnPlusInterval);
			});
		}

		/**
		 * common function to set incrementer value/display for click/hold events
		 * @param  {any}    elDisplay [description]
		 * @param  {any}    input     [description]
		 * @param  {any}    curVal    [description]
		 * @param  {any}    params    [description]
		 * @param  {string} type      [description]
		 * @return {any}              [description]
		 */
		function setIncrementer(elDisplay:any, input:any, curVal:any, params:any, type:string):any {
			if (type == 'decrement') {
				if (curVal > params.min) {
					curVal--;
				}
			}

			if (type == 'increment') {
				if (curVal < params.max) {
					curVal++;
				}
			}


			elDisplay.html(curVal);
			input.val(curVal);

			input.parent().trigger('incrementer.changed', [curVal]);

			return curVal;

		}
	}

	validateForm(form: any, customValidation:any, onSuccess:any): any {
		let _self = this;
		let submitBtn:any = form.find('.btn-member--submit');
		let _window:any   = window;
		let formData:Array<any> = [];
		let validation:any = form.parsley({
			errorClass: 'has-error',
	        classHandler: function (el:any) {
	            return el.$element.closest('.form-item');
	        },
		});

		// custom validation here
		// pass in validation instance and validation summary objects
		// for use in callback
		if (typeof customValidation === 'function') {
			customValidation(validation);
		}
		
		// validate on click submit
		submitBtn.on('click', function(e:any) {
			e.stopPropagation();
			e.preventDefault();
			// for contact form
			
			// update profile Validation

			if($('#update-preprofile--passport-number').length>1)
			{
				if($('.update-preprofile--passport-number').val()!="" || $('.update-profile--passport-issuing-country').val()!="" || $('.update-preprofile--passport-expiry-date').val()!="")
				{
					$('#update-preprofile--passport-number').attr({
						'data-parsley-required': "true",
					});	
					$('.update-preprofile--passport-expiry-date').attr({
						'data-parsley-required': "true",
					});	
					$('.update-profile--passport-issuing-country').attr({
						'data-parsley-required': "true",
					});	
				}
			}

			if($(e.currentTarget).attr('disabled')) {
				return;
			}
			let validationResult:any = validation.validate();
			
			if (validationResult) {
				formData = form.find('input:not([id*="-selectized"]), select, textarea').serializeArray();

				let fileInputs:any = form.find('input[type="file"]');
				if (fileInputs.length) {
					fileInputs.each(function(){
						let fileEl:any = $(this);
						formData.push({
							"name": fileEl[0].getAttribute('name'),
							"value": fileEl[0].files
						});
					});
				}
				let htmlFormData:any = new FormData(validation.$element[0]);
				let bcommon = _self.bookingformcommon;
				// alert('Form submitted, view console log for params.');
				switch (form.attr('id')) {
					case 'member-change-password': {
						bcommon.preloader();
						$.ajax({
							type: 'POST',
							url: '/bin/services/new/updatepassword',
							data: formData,
							success: function(msg:any) {
								_self.redirectUser(msg);
								if (msg == "T") {
									if (typeof onSuccess === 'function') {
										onSuccess(validation, formData);
									}
								} else {
									$("#member-change-password .error-validation").show();
									$("#member-change-password .error-validation").html(msg);
								}
								bcommon.preloaderClose();
							},
							error: function(error:any) {
								$("#member-change-password .error-validation").show();
								$("#member-change-password .error-validation").html(error);
								bcommon.preloaderClose();
							}
						});
						break;
					}
					case 'member-change-password': {
						bcommon.preloader();
						$.ajax({
							type: 'POST',
							url: '/bin/services/new/updatepassword',
							data: formData,
							success: function(msg:any) {
								_self.redirectUser(msg);
								if (msg == "T") {
									if (typeof onSuccess === 'function') {
										onSuccess(validation, formData);
									}
								} else {
									$("#member-change-password .error-validation").show();
									$("#member-change-password .error-validation").html(msg);
								}
								bcommon.preloaderClose();
							},
							error: function(error:any) {
								$("#member-change-password .error-validation").show();
								$("#member-change-password .error-validation").html(error);
								bcommon.preloaderClose();
							}
						});
						break;
					}
					case 'member-add-travel-coordinator': {
						bcommon.preloader();
						$.ajax({
							type: 'POST',
							url: '/bin/services/new/travelcoordinator',
							data: formData,
							success: function(msg:any) {
								_self.redirectUser(msg);
								if (msg == "OK") {
									bcommon.preloaderClose();
									var currentUrl = window.location.href;
									if (!currentUrl.indexOf(".html")) {
										window.location.href = currentUrl + "&result=success";
									} else {
										window.location.href = currentUrl + "?result=success";
									}
								}
							},
							error: function(error:any) {
								bcommon.preloaderClose();
							}
						});
						break;
					}
					case 'member-personaldetails-update': {
						$('#title_error').remove('');
						let $titleselect: any = $('#update-profile--title');
						let $dateOfBirth: any = $("#update-profile--date-of-birth");
						let $dateOfBirthValue:any = $dateOfBirth.val();	
						let $titleselectvalue = $titleselect.val();
						var today = new Date();
						const birthDate = new Date($('#update-profile--date-of-birth').val());
						const one_or_zero:any = (today.getMonth() < birthDate.getMonth()) ||
						(today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate());
						const year_difference = today.getFullYear() - birthDate.getFullYear();
						const age = year_difference - one_or_zero;
						// var age = today.getFullYear() - birthDate.getFullYear();
						if (($titleselectvalue == 'Miss' || $titleselectvalue == 'Master') && age > 12) {
							$('#update-profile--date-of-birth').after('<div class="error" id="title_error">Age must be 12 years old or below for selected title</div>');
							$('#title_error').css('display', 'block');
							$('#title_error').css('color', '#ed1c24');
							$('#title_error').css('font-size', '.75rem');
						} else {
							$('#title_error').remove('');
						bcommon.preloader();
						_self.adobeDataLayer.push('click', {
							'pageName': '',
							'pageType': 'Enrich Profile - Personal Details',
							'clickName': 'click:btn-click:personal-details-update',
							'componentType': 'btn',
							'componentName': '',
							'componentID': '',
							'attributes': []
						});
						var checkBoxes = "";

						var consents="";
						let populateurl = $('[data-get-updateprofile-url]').attr('data-get-updateprofile-url');
						//alert("populateurl>>"+populateurl);
						$(".update--lcp--profile--consents--add").each(function() {
							//if ($(this).is(':checked')) {
								if(this.checked){
								if(consents!=""){
									consents =consents+","+$(this).val();
								}else{
									consents=$(this).val();
								}
							}
						});

						//alert("consents>"+consents);

						formData.push({
							name: "consents",
							value: consents
						});

						$(".update-profile--interest-preferences input").each(function() {
							if ($(this).is(':checked')) {
								checkBoxes += "," + $(this).val();
							}
						});

						var festivals = "";

						$(".update-profile--festival-preferences input").each(function() {
							if ($(this).is(':checked')) {
								festivals += "," + $(this).val();
							}
						});
						checkBoxes = checkBoxes + festivals + ",";
						formData.push({
							name: "checkBoxes",
							value: checkBoxes
						});
						formData.push({
							name: "personal-email",
							value: $("#update-profile--personal-email").val()
						});
						formData.push({
							name: "personal-phone-mobile-country-code",
							value: $("#update-profile--personal-phone-mobile-country-code").val()
						});
						formData.push({
							name: "personal-phone-mobile",
							value: $("#update-profile--personal-phone-mobile").val()
						});
						if(_self.getProfileCookie('profileSessionEnabled').length === 0) {
							let disbaledFields = [
								{name: "title" , id: "update-profile--title"},
								{name: "nationality" , id: "update-profile--nationality"},
								{name: "nric-number" , id: "update-profile--nric-number"},
								{name: "personal-address-line-1" , id: "update-profile--personal-address-line-1"},
								{name: "personal-address-line-2", id: "update-profile--personal-address-line-2"},
								{name: "personal-address-line-3" , id: "update-profile--personal-address-line-3"},
								{name: "personal-states" , id: "update-profile--personal-states"},
								{name: "personal-address-postcode" , id: "update-profile--personal-address-postcode"},
								{name: "personal-address-city", id: "update-profile--personal-address-city"},
								{name: "passport-number", id: "update-preprofile--passport-number"},
								{name: "passport-expiry-date", id: "update-preprofile--passport-expiry-date"},
								{name: "passport-issuing-country", id: "update-profile--passport-issuing-country"},
								{name: "personal-countries", id: "update-profile--personal-countries"}
							];
							disbaledFields.map((field: any) => {
								formData.push({
									name: field.name,
									value: $('#'+field.id).val()
								});
							});
						}
						
						$.ajax({
							type: 'POST',
							url: populateurl,
							data: formData,
							success: function(msg:any) {
								_self.redirectUser(msg);
								bcommon.preloaderClose();
								if (msg == "OK" || msg == "00" || msg == "03") {
									/*$("#update-profile-success").removeClass("hideclass"); //DISPLAY
									$("#update-profile-success").addClass("showclass"); //DISPLAY
									$("#update-profile-failure").removeClass("showclass"); //DISPLAY
									$("#update-profile-failure").addClass("hideclass"); //DISPLAY
									$("#update-profile-failure").fadeIn();*/
									$('html, body').animate({
										'scrollTop': 0
									}, 500, function() {
										$("#update-profile-success").fadeIn();
										$("#update-profile-failure").fadeOut();
									});
								}else{
									/*$("#update-profile-success").removeClass("showclass"); //DISPLAY
									$("#update-profile-success").addClass("hideclass"); //DISPLAY
									$("#update-profile-failure").removeClass("hideclass"); //DISPLAY
									$("#update-profile-failure").addClass("showclass"); //DISPLAY*/
									$('html, body').animate({
										'scrollTop': 0
									}, 500, function() {
										$("#update-profile-failure").fadeIn();
										$("#update-profile-success").fadeOut();
									});

								}
							},
							error: function(error:any) {
								bcommon.preloaderClose();
								if(error.responseText == "OK"){
									$('html, body').animate({
										'scrollTop': 0
									}, 500, function() {
										$("#update-profile-success").fadeIn();
									});
								}
							}
						});
					}
						break;
					}			
				
					case 'member-profile-update': {
						bcommon.preloader();

						var checkBoxes = "";

						var consents="";
						let populateurl = $('[data-get-updateprofile-url]').attr('data-get-updateprofile-url');
						//alert("populateurl>>"+populateurl);
						$(".update--lcp--profile--consents--add").each(function() {
							//if ($(this).is(':checked')) {
								if(this.checked){
								if(consents!=""){
									consents =consents+","+$(this).val();
								}else{
									consents=$(this).val();
								}
							}
						});

						//alert("consents>"+consents);

						formData.push({
							name: "consents",
							value: consents
						});

						$(".update-profile--interest-preferences input").each(function() {
							if ($(this).is(':checked')) {
								checkBoxes += "," + $(this).val();
							}
						});

						var festivals = "";

						$(".update-profile--festival-preferences input").each(function() {
							if ($(this).is(':checked')) {
								festivals += "," + $(this).val();
							}
						});

						checkBoxes = checkBoxes + festivals + ",";
						formData.push({
							name: "checkBoxes",
							value: checkBoxes
						});

						formData.push({
							name: "date-of-birth",
							value: $("#update-profile--date-of-birth").val()
						});

						formData.push({
							name: "personal-email",
							value: $("#update-profile--personal-email").val()
						});
						
						$.ajax({
							type: 'POST',
							url: populateurl,
							data: formData,
							success: function(msg:any) {
								_self.redirectUser(msg);
								bcommon.preloaderClose();
								if (msg == "OK" || msg == "00" || msg == "03") {
									$('html, body').animate({
										'scrollTop': 0
									}, 500, function() {
										$("#update-profile-success").fadeIn();
									});
								}
							},
							error: function(error:any) {
								bcommon.preloaderClose();
								if(error.responseText == "OK"){
									$('html, body').animate({
										'scrollTop': 0
									}, 500, function() {
										$("#update-profile-success").fadeIn();
									});
								}
							}
						});
						break;
					}
					case 'member-forgotmhnum-form': {
						bcommon.preloader();
						$("#member-forgotmhnum-form .error-validation").html("");
						$("#member-forgotmhnum-form .error-validation").css("display", "none");
						$("#member-forgotmhnum-form .error-validation").removeClass('mandatory-text');
						$.ajax({
						    type: 'POST',
						    url: '/bin/services/new/forgotmhnumber',
						    data: formData,
						    success: function(msg:any) {
						        _self.redirectUser(msg);
						        if (msg == "success") {
						            //show success message
						            if (typeof onSuccess === 'function') {
						                bcommon.preloaderClose();
						                onSuccess(validation, formData);
						            }
						        } else {
						            //show error message
						            $("#member-forgotmhnum-form .error-validation").html($("#forgotErrMsg").val());
						            $("#member-forgotmhnum-form .error-validation").css("display", "block");
						            $("#member-forgotmhnum-form .error-validation").addClass('mandatory-text');
						            bcommon.preloaderClose();
						        }
						    },
						    error: function(error:any) {
						        bcommon.preloaderClose();
						        //show error message
						    }
						});
						break;
					}
					case 'member-forgotpw-form': {
						bcommon.preloader();
						$("#member-forgotpw-form .error-validation").html("");
						$("#member-forgotpw-form .error-validation").css("display", "none");
						$("#member-forgotpw-form .error-validation").removeClass('mandatory-text');
						$.ajax({
						    type: 'POST',
						    url: '/bin/services/new/forgotpassword',
						    data: formData,
						    success: function(msg:any) {
						        _self.redirectUser(msg);
						        if (msg == "success") {
						            //show success message
						            if (typeof onSuccess === 'function') {
						                bcommon.preloaderClose();
						                onSuccess(validation, formData);
						            }
						        } else {
						            //show error message
						            $("#member-forgotpw-form .error-validation").html($("#forgotErrMsg").val());
						            $("#member-forgotpw-form .error-validation").css("display", "block");
						            $("#member-forgotpw-form .error-validation").addClass('mandatory-text');
						            bcommon.preloaderClose();
						        }
						    },
						    error: function(error:any) {
						        bcommon.preloaderClose();
						        //show error message
						    }
						});
						break;
					}
					case 'member-contact-form': {
						bcommon.preloader();
						$("#successMessage").hide();
						$("#member-contact-form .error-validation").html("");
						$("#member-contact-form .error-validation").css("display", "none");
						$("#member-contact-form .error-validation").removeClass('mandatory-text');
						let selectedCategory = $('#member--selected-category').attr("selected-category");
						let newContactUsStatus = $("#oldContactForm").attr("data-new-contact-form-enabled");
						let url = newContactUsStatus == "true" ? "/bin/services/new/enrichContactUs" : "/bin/services/new/enrichcontactus";
						if(newContactUsStatus == "lcp"){
							url = "/bin/services/new/enrichContactUsLCP";
						}
						htmlFormData.append('selected-category', selectedCategory);
						$.ajax({
						    type: 'POST',
						    url: url,
						    data: htmlFormData,
						    success: function(msg:any) {
						        _self.redirectUser(msg);
						        if (msg == "success") {
						            //show success message
									$("#successMessage").show();
						            if (typeof onSuccess === 'function') {
						                bcommon.preloaderClose();
						                onSuccess(validation, formData);
										$("#member-contact-form").hide();
						            }
						        } else {
						            //show error message
						            $("#member-contact-form .error-validation").html($("#forgotErrMsg").val());
						            $("#member-contact-form .error-validation").css("display", "block");
						            $("#member-contact-form .error-validation").addClass('mandatory-text');
						            bcommon.preloaderClose();
						        }
						    },
						    error: function(error:any) {
						        bcommon.preloaderClose();
						        //show error message
						    },
						    cache: false,
						    contentType: false,
						    processData: false,
						    //async:false
						});
						break;
					}
					case 'claim-airlines-mab-form': {
						bcommon.preloader();
						$("#claim-airlines-mab-form .error-validation").html("");
						$("#claim-airlines-mab-form .error-validation").css("display", "none");
						$("#claim-airlines-mab-form .error-validation").removeClass('mandatory-text');
						$.ajax({
						    type: 'POST',
						    url: '/bin/services/new/claimownairline',
						    data: formData,
						    success: function(msg:any) {
						        _self.redirectUser(msg);
						        var obj = JSON.parse(JSON.stringify(msg));
						        if (obj.errorCode == "OK") {
						            //show success message
						            /*$(
						                    "#claim-airlines-mab-form .mandatory-text")
						                .html(
						                obj.processStatus);*/
						            if (typeof onSuccess === 'function') {
						                bcommon.preloaderClose();
						                onSuccess(validation, formData);
						            }
						        } else {
						            //show error message
						            $("#claim-airlines-mab-form .error-validation").css("display", "block");
						            $("#claim-airlines-mab-form .error-validation").html(obj.processStatus);
						            bcommon.preloaderClose();
						        }
						    },
						    error: function(error:any) {
						        bcommon.preloaderClose();
						        //show error message
						    }
						});
						break;
					}
					case 'claim-airlines-partners-form': {
						bcommon.preloader();
							let changedAirilnePartner = $('#claimAirlinesPartnersChanged').attr("data-claim-partners--airline-partner-changed");
							htmlFormData.append('airline-partner-changed', changedAirilnePartner);
							$("#claim-airlines-partners-form .error-validation").html("");
							$("#claim-airlines-partners-form .error-validation").css("display", "none");
							$("#claim-airlines-partners-form .error-validation").removeClass('mandatory-text');
							let newClaimAirlinesEnabled = $("#claimAirlinesPartnersForm").attr("data-is-new-claim-airlines-enabled");
							let url = newClaimAirlinesEnabled == "true" ? "/bin/services/new/claimAirlinePartner" : "/bin/services/new/claimpartnerairline";
							$.ajax({
							    type: 'POST',
							    url: url,
							    data: htmlFormData,
							    success: function(msg:any) {
							        _self.redirectUser(msg);
							        //debugger;
							        var obj = JSON.parse(JSON.stringify(msg));
							        if (obj.errorCode == "OK") {
							            bcommon.preloaderClose();
							            //show success message
							            /*$(
							                    "#claim-airlines-partners-form .mandatory-text")
							                .html(
							                obj.processStatus);*/
							            if (typeof onSuccess === 'function') {
							                bcommon.preloaderClose();
							                onSuccess(validation, formData);
							            }
							        } else {
							            bcommon.preloaderClose();
							            //show error message
							            $("#claim-airlines-partners-form .error-validation").css("display", "block");
										if(newClaimAirlinesEnabled == "true") {
											$("#claim-airlines-partners-form .error-validation").html(obj.message);
										} else {
											$("#claim-airlines-partners-form .error-validation").html(obj.processStatus);
										}
							            
							        }
							    },
							    error: function(error:any) {
							        bcommon.preloaderClose();
							        //show error message
							    },
							    cache: false,
							    contentType: false,
							    processData: false,
							});
						break;
					}
					case 'claim-airlines-mab-form--lcp': {
						bcommon.preloader();
						$("#claim-airlines-mab-form--lcp .error-validation").html("");
						$("#claim-airlines-mab-form--lcp .error-validation").css("display", "none");
						$("#claim-airlines-mab-form--lcp .error-validation").removeClass('mandatory-text');
						_self.adobeDataLayer.push('click', {
							'pageName': 'mas:my:en:enrich-portal:home:activity',
							'pageType': 'Enrich Activity Page',
							'clickName': 'click:btn-click:claim-missing-malaysia-airlines-points-submit',
							'componentType': 'btn',
							'componentName': 'Claim Missing Points Submit Btn',
							'componentID': 'claim-miles--submit',
							'attributes': [
								{
									'key' : 'flightDate',
									'value': formData[1].value,
								},
								{
									'key' : 'flightNumber',
									'value': formData[2].value,
								},
								{
									'key' : 'origin',
									'value': formData[3].value,
								},
								{
									'key' : 'destination',
									'value': formData[4].value,
								},
								{
									'key' : 'ticketNumber',
									'value': formData[5].value,
								},
								{
									'key' : 'flightClass',
									'value': formData[6].value,
								},
								{
									'key' : 'pnr',
									'value': formData[7].value,
								}
							]
							
						});
						$.ajax({
						    type: 'POST',
						    url: '/bin/services/new/claimownairlineLCP',
						    data: formData,
						    success: function(msg:any) {
								_self.redirectUser(msg);
								let json:any = null;
								if (typeof msg === 'string') {
									json = JSON.parse(msg);
								}	else {
									json = msg;
								}
						        //var obj = JSON.parse(JSON.stringify(msg));
						        if (json.errorCode == "OK") {
						            //show success message
						            /*$(
						                    "#claim-airlines-mab-form .mandatory-text")
						                .html(
						                obj.processStatus);*/
						            if (typeof onSuccess === 'function') {
						                bcommon.preloaderClose();
						                onSuccess(validation, formData);
						            }
						        } else {
						            //show error message
						            $("#claim-airlines-mab-form--lcp .error-validation").css("display", "block");
						            $("#claim-airlines-mab-form--lcp .error-validation").html(json.message);
						            bcommon.preloaderClose();
						        }
						    },
						    error: function(error:any) {
						        bcommon.preloaderClose();
						        //show error message
						    }
						});
						break;
					}
					case 'claim-airlines-partners-form--lcp': {
						bcommon.preloader();
							let changedAirilnePartner = $('#claimAirlinesPartnersChanged').attr("data-claim-partners--airline-partner-changed");
							htmlFormData.append('airline-partner-changed', changedAirilnePartner);
							$("#claim-airlines-partners-form--lcp .error-validation").html("");
							$("#claim-airlines-partners-form--lcp .error-validation").css("display", "none");
							$("#claim-airlines-partners-form--lcp .error-validation").removeClass('mandatory-text');
							let newClaimAirlinesEnabled = $("#claimAirlinesPartnersForm").attr("data-is-new-claim-airlines-enabled");
							let url = newClaimAirlinesEnabled == "true" ? "/bin/services/new/claimownairlineLCP" : "/bin/services/new/claimpartnerairline";
							_self.adobeDataLayer.push('click', {
								'pageName': 'mas:my:en:enrich-portal:home:activity',
								'pageType': 'Enrich Activity Page',
								'clickName': 'click:btn-click:claim-missing-points-other-airlines-submit',
								'componentType': 'btn',
								'componentName': 'click:btn-click:claim-missing-points-other-airlines-submit',
								'componentID': 'claim-partners-submit',
								'attributes': [
									{
										'key' : 'airlinePartner',
										'value': formData[2].value,
									},
									{
										'key' : 'flightDate',
										'value': formData[3].value,
									},
									{
										'key' : 'flightNumber',
										'value': formData[4].value,
									},
									{
										'key' : 'origin',
										'value': formData[5].value,
									},
									{
										'key' : 'destination',
										'value': formData[6].value,
									},
									{
										'key' : 'ticketNumber',
										'value': formData[7].value,
									},
									{
										'key' : 'flightClass',
										'value': formData[8].value,
									}
								]
						
							});
							$.ajax({
							    type: 'POST',
							    url: url,
							    data: htmlFormData,
							    success: function(msg:any) {
							        _self.redirectUser(msg);
							        //debugger;
							       // var obj = JSON.parse(JSON.stringify(msg));
							       let json:any = null;
								if (typeof msg === 'string') {
									json = JSON.parse(msg);
								}	else {
									json = msg;
								}
						        //var obj = JSON.parse(JSON.stringify(msg));
						        if (json.errorCode == "OK") {
							            bcommon.preloaderClose();
							            //show success message
							            /*$(
							                    "#claim-airlines-partners-form .mandatory-text")
							                .html(
							                obj.processStatus);*/
							            if (typeof onSuccess === 'function') {
							                bcommon.preloaderClose();
							                onSuccess(validation, formData);
							            }
							        } else {
							            bcommon.preloaderClose();
							            //show error message
							            $("#claim-airlines-partners-form--lcp .error-validation").css("display", "block");
							            $("#claim-airlines-partners-form--lcp .error-validation").html(json.message);
							        }
							    },
							    error: function(error:any) {
							        bcommon.preloaderClose();
							        //show error message
							    },
							    cache: false,
							    contentType: false,
							    processData: false,
							});
						break;
					}
					case 'claim-airlines-others-form--lcp': {
						bcommon.preloader();
							let changedAirilnePartner = $('#claimAirlinesOthersChanged').attr("data-claim-others--changed");
							htmlFormData.append('others-partner-changed', changedAirilnePartner);
							$("#claim-airlines-others-form--lcp .error-validation").html("");
							$("#claim-airlines-others-form--lcp .error-validation").css("display", "none");
							$("#claim-airlines-others-form--lcp .error-validation").removeClass('mandatory-text');
							let newClaimNonAirlinesEnabled = $("#claimNonAirlinesPartnersForm").attr("data-is-new-claim-non-airlines-enabled");
							let url = newClaimNonAirlinesEnabled == "true" ? "/bin/services/new/claimNonAirline" : "/bin/services/new/claimnonairline";
							_self.adobeDataLayer.push('click', {
								'pageName': 'mas:my:en:enrich-portal:home:activity',
								'pageType': 'Enrich Activity Page',
								'clickName': 'click:btn-click:claim-missing-points-non-airlines-submit',
								'componentType': 'btn',
								'componentName': 'click:btn-click:claim-missing-points-non-airlines-submit',
								'componentID': 'claim-others-submit',
								'attributes': [
									{
										'key' : 'enrichPartner',
										'value': formData[2].value,
									},
									{
										'key' : 'transactionDate',
										'value': formData[3].value,
									},
									{
										'key' : 'proofOfActivity',
										'value': formData[4].value,
									},
									{
										'key' : 'locationOfService',
										'value': formData[5].value,
									}
								]
							});
							$.ajax({
							    type: 'POST',
							    url: url,
							    data: htmlFormData,
							    success: function(msg:any) {
							        _self.redirectUser(msg);
							        //debugger;
							       // var obj = JSON.parse(JSON.stringify(msg));
							       let json:any = null;
								if (typeof msg === 'string') {
									json = JSON.parse(msg);
								}	else {
									json = msg;
								}
						        //var obj = JSON.parse(JSON.stringify(msg));
						        if (json.errorCode == "OK") {
							            bcommon.preloaderClose();
							            //show success message
							            /*$(
							                    "#claim-airlines-partners-form .mandatory-text")
							                .html(
							                obj.processStatus);*/
							            if (typeof onSuccess === 'function') {
							                bcommon.preloaderClose();
							                onSuccess(validation, formData);
							            }
							        } else {
							            bcommon.preloaderClose();
							            //show error message
							            $("#claim-airlines-others-form--lcp .error-validation").css("display", "block");
							            $("#claim-airlines-others-form--lcp .error-validation").html($("#errorMessageRC").html());
							        }
							    },
							    error: function(error:any) {
							        bcommon.preloaderClose();
							        //show error message
							    },
							    cache: false,
							    contentType: false,
							    processData: false,
							});
						break;
					}
					case 'claim-airlines-others-form': {
						bcommon.preloader();
						$("#claim-airlines-others-form .error-validation").html("");
						$("#claim-airlines-others-form .error-validation").css("display", "none");
						$("#claim-airlines-others-form .error-validation").removeClass('mandatory-text');
						let newClaimNonAirlinesEnabled = $("#claimNonAirlinesPartnersForm").attr("data-is-new-claim-non-airlines-enabled");
						let url = newClaimNonAirlinesEnabled == "true" ? "/bin/services/new/claimNonAirlinePartner" : "/bin/services/new/claimnonairline";
						$.ajax({
						    type: 'POST',
						    url: url,
						    data: htmlFormData,
						    success: function(msg:any) {
						        _self.redirectUser(msg);
						        //debugger;
						        var obj = JSON.parse(JSON.stringify(msg));
						        if (obj.errorCode == "OK") {
						            bcommon.preloaderClose();
						            //show success message
						            /*$(
						                    "#claim-airlines-others-form .mandatory-text")
						                .html(
						                obj.processStatus);*/
						            if (typeof onSuccess === 'function') {
						                onSuccess(validation, htmlFormData);
						            }
						        } else {
						            //show error message
						            $("#claim-airlines-others-form .error-validation").css("display", "block");
									if(newClaimNonAirlinesEnabled == "true") {
										$("#claim-airlines-others-form .error-validation").html(obj.message);
									} else {
										$("#claim-airlines-others-form .error-validation").html(obj.processStatus);
									}
						            
						            bcommon.preloaderClose();
						        }
						    },
						    error: function(error:any) {
						        bcommon.preloaderClose();
						        //show error message
						    },
						    cache: false,
						    contentType: false,
						    processData: false,
						});
						break;
					}
					case 'miles-redeem-enrich-vouchers-form': {
						bcommon.preloader();
						$("#miles-redeem-enrich-vouchers-form .error-validation").html("");
						$("#miles-redeem-enrich-vouchers-form .error-validation").css("display", "none");
						$("#miles-redeem-enrich-vouchers-form .error-validation").removeClass('mandatory-text');
						$.ajax({
						    type: 'POST',
						    url: '/bin/services/new/enrichvoucher',
						    data: formData,
						    success: function(msg:any) {
						        _self.redirectUser(msg);
						        if (msg == "OK") {
						            bcommon.preloaderClose();
						            //alert("Your voucher is submitted. You will get a mail shortly");// "/content/mas-uat/master/en.html";
						            //												what to show for the success message.
						            window.location.href = $("#successRedirection").val();
						        } else {
						            $("#miles-redeem-enrich-vouchers-form .error-validation").html($("#enrichVoucherError").val());
						            $("#miles-redeem-enrich-vouchers-form .error-validation").css("display", "block");
						            $("#miles-redeem-enrich-vouchers-form .error-validation").addClass('mandatory-text');
						            bcommon.preloaderClose();
						        }
						    },
						    error: function(error:any) {
						        $("#miles-redeem-enrich-vouchers-form .error-validation").html($("#enrichVoucherError").val());
						        $("#miles-redeem-enrich-vouchers-form .error-validation").css("display", "block");
						        $("#miles-redeem-enrich-vouchers-form .error-validation").addClass('mandatory-text');
						        bcommon.preloaderClose();
						    }
						});
						break;
					}
					case 'golden-redeem-voucher-form': {
						$("#golden-redeem-voucher-form .error-validation").html("");
						$("#golden-redeem-voucher-form .error-validation").css("display", "none");
						$("#golden-redeem-voucher-form .error-validation").removeClass('mandatory-text');
						var currentMile = $(".miles-value").html().replace(/,/g , ""); // remove comma from miles value
						var totalmiles = $("#golden-redeem--voucher-total").val();
						if (parseInt(totalmiles) > parseInt(currentMile)) {
						    var error_message = $("#golden-redeem-voucher-error-msg").val();
						    $(".error-validation").html(' <p id="error-miles"><a class="focus-golden-redeememail" href="#">' + error_message + '</a></p>');
						    $(".error-validation").css("display", "block");
						} else {
						    bcommon.preloader();
						    var data = {
						        'voucher-type': formData[0].value,
						        'voucher-to-use': formData[1].value
						    }
						    $.ajax({
						        type: 'POST',
						        url: '/bin/services/new/redeemvoucher',
						        data: formData,
						        success: function(msg:any) {
						            _self.redirectUser(msg);
						            if (msg == true) {
						                // Show success message.
						                bcommon.preloaderClose();
						                // alert("Your voucher is sent to your email address.");
						                window.location.href = $("#golden-redeem-voucher-success-msg").val();
						            } else {
						                // Show error message.
						                // alert("There is some error while generating the voucher....");
						                $("#golden-redeem-voucher-form .error-validation").html($("#golden-redeem-voucher-error-msgr").val());
						                $("#golden-redeem-voucher-form .error-validation").css({
						                    'display': 'block'
						                });
						                $("#golden-redeem-voucher-form .error-validation").addClass('mandatory-text');
						                bcommon.preloaderClose();
						            }
						        },
						        error: function(error: any) {
						            // alert("There is some error while generating the voucher....");
						            $("#golden-redeem-voucher-form .error-validation").html($("#golden-redeem-voucher-error-msg").val());
						            $("#golden-redeem-voucher-form .error-validation").css({
						                'display': 'block'
						            });
						            $("#golden-redeem-voucher-form .error-validation").addClass('mandatory-text');
						            bcommon.preloaderClose();
						        }
						    });
						}
						break;
					}
					case 'member-register-form': {
						bcommon.preloader();
						$("#member-register-form .error-validation").html("");
						$("#member-register-form .error-validation").css("display", "none");
						$("#member-register-form .error-validation").removeClass('mandatory-text');
						$.ajax({
						    type: 'POST',
						    url: '/bin/services/new/registeruser',
						    data: formData,
						    success: function(msg:any) {
						        _self.redirectUser(msg);
						        bcommon.preloaderClose();
						        if (msg != "") {
						            var json = JSON.parse(msg);
						            if (json.membershipStatus == "") {
						                bcommon.preloaderClose();
						                document.cookie = "tempCard=" + msg + ";path=/";
						                window.location.href = $("#redirectionPath").val();
						            } else {
						                bcommon.preloaderClose();
						                $("#member-register-form .error-validation").html(json.membershipStatus);
						                $("#member-register-form .error-validation").css("display", "block");
						                $("#member-register-form .error-validation").addClass('mandatory-text');
						                $('body').animate({
						                    'scrollTop': 100
						                }, 500, function() {});
						            }
						        }
						    },
						    error: function(error:any) {
						        bcommon.preloaderClose();
						        $("#member-register-form .error-validation").html("Unable to perform the registration due to some network problem!");
						        $("member-register-form .error-validation").css("display", "block");
						        $("member-register-form .error-validation").addClass('mandatory-text');
						        $('body').animate({
						            'scrollTop': 100
						        }, 500, function() {});
						    }
						});
						break;
					}
					case 'enrich-voucher-redemption': {
						bcommon.preloader();
						$("#enrich-voucher-redemption .error-validation").html("");
						$("#enrich-voucher-redemption .error-validation").css("display", "none");
						$("#enrich-voucher-redemption .error-validation").removeClass('mandatory-text');
						let authenticationUrl: string = '';
						if (window.location.hostname === 'localhost' && window.location.port == "5000") {
							authenticationUrl = '/dummy-data/voucherLogin.json';
						}
						else {
							authenticationUrl = '/bin/services/new/partnerportal/authentication';
						}

						$.ajax({
						    type: 'POST',//Change to POST if required
						    url: authenticationUrl,
						    data: formData,
						    success: function(msg:any) {						       
						        bcommon.preloaderClose();
						        if (msg != "") {
									var json = msg;
									if (typeof msg === 'string') {
										json=JSON.parse(msg);
									}						           
						            if (json.processStatus == "SUCCESS") {			
										let isUserLoggedIn = _self.getCookie("p_loggedinuser");
										if(isUserLoggedIn){
											$("#enrich-input-voucher-redemption").removeClass("hideclass");
											$("#enrich-voucher-redemption").addClass("hideclass");
											$(" #enrich-used-voucher-partner").removeClass("hide");
											bcommon.preloaderClose();
										}else{
											bcommon.preloaderClose();
											$("#enrich-voucher-redemption .error-validation").html("Something went wrong, Please try again after sometime.");
						                	$("#enrich-voucher-redemption .error-validation").css("display", "block");
						                	$("#enrich-voucher-redemption .error-validation").addClass('mandatory-text');
										}
						            } else {
						                bcommon.preloaderClose();
						                $("#enrich-voucher-redemption .error-validation").html("User Not Found/Password Does Not Match");
						                $("#enrich-voucher-redemption .error-validation").css("display", "block");
						                $("#enrich-voucher-redemption .error-validation").addClass('mandatory-text');
						                $('body').animate({
						                    'scrollTop': 100
						                }, 500, function() {});
						            }
						        }
						    },
						    error: function(error:any) {
						        bcommon.preloaderClose();
						        $("#enrich-voucher-redemption .error-validation").html("Unable to perform the login due to some network problem!");
						        $("#enrich-voucher-redemption .error-validation").css("display", "block");
						        $("#enrich-voucher-redemption .error-validation").addClass('mandatory-text');
						        $('body').animate({
						            'scrollTop': 100
						        }, 500, function() {});
						    }
						});
						break;

					}
					case 'enrich-input-voucher-redemption': {
						bcommon.preloader();
						$("#enrich-input-voucher-redemption .error-validation").html("");
						$("#enrich-input-voucher-redemption .error-validation").css("display", "none");
						$("#enrich-input-voucher-redemption .error-validation").removeClass('mandatory-text');
						formData.push ({
							"name": "username",
							"value": $('#enrich-voucher-redemption #enrich-redemption--username').val()
						});
						
						let isUserLoggedIn = _self.getCookie("p_loggedinuser");
				
						if(isUserLoggedIn){
							let voucherredeemInputUrl: string = '';
							if (window.location.hostname === 'localhost' && window.location.port == "5000") {
								voucherredeemInputUrl = '/dummy-data/vouchercode.json';
							}
							else {
								voucherredeemInputUrl = '/bin/services/new/partnerportal/checkvoucher';
							}
							$.ajax({
								type: 'POST',//Change to POST if required
								url: voucherredeemInputUrl,
								data: formData,
								success: function(msg1:any) {						       
									bcommon.preloaderClose();
									if (msg1 != "") {
										var json = msg1;
										if (typeof msg1 === 'string') {
											json=JSON.parse(msg1);
										}						           
										if (json.voucherValid == true) {	
											$('#enrich-voucher--redemption-no').addClass('input-focused').removeClass('has-error');
											$('#enrich-voucher--redemption-no').parent().addClass('input-focused');
											$('#enrich-voucher--redemption-no').parent().find('label').addClass('input-filled').removeClass('has-error');			
											$('#enrich-voucher--redemption-scratch-id').addClass('input-focused').removeClass('has-error');
											$('#enrich-voucher--redemption-scratch-id').parent().addClass('input-focused');
											$('#enrich-voucher--redemption-scratch-id').parent().find('label').addClass('input-filled').removeClass('has-error');								
											$('#enrich-voucher--redemption-ownername').addClass('input-focused').removeClass('has-error');
											$('#enrich-voucher--redemption-ownername').parent().addClass('input-focused');
											$('#enrich-voucher--redemption-ownername').parent().find('label').addClass('input-filled').removeClass('has-error');								
											$('#enrich-voucher--redemption-status').addClass('input-focused').removeClass('has-error');
											$('#enrich-voucher--redemption-status').parent().addClass('input-focused');
											$('#enrich-voucher--redemption-status').parent().find('label').addClass('input-filled').removeClass('has-error');													
											$('#enrich-voucher--redemption-no').val(json.voucherCode);
											$('#enrich-voucher--redemption-scratch-id').val(json.enrichID);
											$('#enrich-voucher--redemption-ownername').val(json.enrichName);
											$('#enrich-voucher--redemption-status').val(json.voucherUsedDate);
											$('#enrich-voucher--redemption-remarks').val(json.remarksFromPartner);
											$('#enrich-voucher--redemption-receipt-number').val(json.receiptNumber);
											$('#enrich-voucher--redemption-receipt-amount').val(json.receiptAmount);
											_self.enrichvoucherpartnername=json.partnerAccount;
											// var val = $('#enrich-voucher--redemption-status').val();
											if (json.voucherUsedDate == "Available to use") {
												$('#enrich-input-voucher-checkingstatus').removeClass("hideclass");
												$(".enrich-redemption-tnc").removeClass("hideclass");
											}
											else {
												$('#enrich-input-voucher-checkingstatus').addClass("hideclass");
												$(".enrich-redemption-tnc").addClass("hideclass");
												$("#enrich-input-voucher-clear").removeClass("col-lg-6");
												$("#enrich-input-voucher-clear").addClass("col-lg-12");
											}
											$("#enrich-input-voucher-redemption").addClass("hideclass");
											$("#enrich-voucher-checking-screen").removeClass("hideclass");
											$("#enrich-input-voucher-checkingstatus").addClass("disabled");
											$(" #enrich-used-voucher-partner").addClass("hide");
											$('#enrich--form--checkbox').attr('checked', false);
											bcommon.preloaderClose();
										} else {
											bcommon.preloaderClose();
											$("#enrich-input-voucher-redemption .error-validation").html("Voucher Not Found");
											$("#enrich-input-voucher-redemption .error-validation").css("display", "block");
											$("#enrich-input-voucher-redemption .error-validation").addClass('mandatory-text');
											$('body').animate({
												'scrollTop': 100
											}, 500, function() {});
										}
									}
								},
								error: function(error:any) {
									bcommon.preloaderClose();
									$("#enrich-input-voucher-redemption .error-validation").html("Unable to perform voucher check due to some network problem!");
									$("#enrich-input-voucher-redemption .error-validation").css("display", "block");
									$("#enrich-input-voucher-redemption .error-validation").addClass('mandatory-text');
									$('body').animate({
										'scrollTop': 100
									}, 500, function() {});
								}
							});
							break;
						}else{
							bcommon.preloaderClose();
							$("#enrich-voucher-redemption").removeClass("hideclass");	
							$("#enrich-input-voucher-redemption").addClass("hideclass");
							$(" #enrich-used-voucher-partner").addClass("hide");	
							window.location.reload();				    				
							break;
						}
					}
					case 'enrich-voucher-checking-screen': {
						bcommon.preloader();
						$("#enrich-input-voucher-redemption .error-validation").html("");
						$("#enrich-input-voucher-redemption .error-validation").css("display", "none");
						$("#enrich-input-voucher-redemption .error-validation").removeClass('mandatory-text');
						let data={
							vouchercode :$("#enrich-voucher--redemption-no").val(),
							remarks:$("#enrich-voucher--redemption-remarks").val(),
							enrichid:$("#enrich-voucher--redemption-scratch-id").val(),
							enrichname:$("#enrich-voucher--redemption-ownername").val(),
							receiptNumber:$("#enrich-voucher--redemption-receipt-number").val(),
							receiptAmount:$("#enrich-voucher--redemption-receipt-amount").val(),
							partnerAccount:_self.enrichvoucherpartnername
						}

						let isUserLoggedIn = _self.getCookie("p_loggedinuser");
						if(isUserLoggedIn){
							let redeemvoucherUrl: string = '';
							if (window.location.hostname === 'localhost' && window.location.port == "5000") {
								redeemvoucherUrl = '/dummy-data/vouchercode.json';
							}
							else {
								redeemvoucherUrl = '/bin/services/new/partnerportal/redeemvoucher';
							}
							$.ajax({
								type: 'POST',//Change to POST if required
								url: redeemvoucherUrl,
								data: data,
								success: function(msg:any) {						       
									bcommon.preloaderClose();
									if (msg != "") {
										var json = msg;
										if (typeof msg === 'string') {
											json=JSON.parse(msg);
										}						           
										if (json.voucherValid == true) {	
											bcommon.preloaderClose();
											$('#enrich-voucher--redemption-no').val(json.voucherCode);
											$('#enrich-voucher--redemption-scratch-id').val(json.enrichID);
											$('#enrich-voucher--redemption-ownername').val(json.enrichName);
											$('#enrich-voucher--redemption-status').val(json.voucherUsedDate);
											$('#enrich-voucher--redemption-remarks').val(json.remarksFromPartner);
											$('#enrich-voucher--redemption-receipt-number').val(json.receiptNumber);
											$('#enrich-voucher--redemption-receipt-amount').val(json.receiptAmount);
											$("#enrich-input-voucher-checkingstatus").addClass("hideclass");
											$("#enrich-input-voucher-clear").removeClass("col-lg-6");
											$("#enrich-input-voucher-clear").addClass("col-lg-12");
												$.magnificPopup.open({
													items: {
														src: '#enrich-voucher-success-popup'
													},
													type: 'inline',
													midClick: true,
													enableEscapeKey: false,
													showCloseBtn: false,
													closeOnBgClick: false,
													modal: true,
													callbacks: {
														open: function() {
															var $content = $(this.content);
															$content.on('click', '.msg-btn-cancel', function() {
																$.magnificPopup.close();
															});
														}
													}
												}, 0);
												$(".enrich-redemption-tnc").addClass("hideclass");
										} else {
											bcommon.preloaderClose();
											$("#enrich-input-voucher-redemption .error-validation").html("Error on submitting request, please try again later");
											$("#enrich-input-voucher-redemption .error-validation").css("display", "block");
											$("#enrich-input-voucher-redemption .error-validation").addClass('mandatory-text');
											$('body').animate({
												'scrollTop': 100
											}, 500, function() {});
											let enrichVouchercheckingpopup:any = form.find('#enrich-input-voucher-checkingstatus');
	
												$.magnificPopup.open({
													items: {
														src: '#enrich-voucher-failure-popup'
													},
													type: 'inline',
													midClick: true,
													enableEscapeKey: false,
													showCloseBtn: false,
													closeOnBgClick: false,
													modal: true,
													callbacks: {
														open: function() {
															var $content = $(this.content);
															$content.on('click', '.msg-btn-cancel', function() {
																$.magnificPopup.close();
															});
														}
													}
												}, 0);
										}
									}
								},
								error: function(error:any) {
									bcommon.preloaderClose();
									$("#enrich-input-voucher-redemption .error-validation").html("Unable to perform voucher check due to some network problem!");
									$("#enrich-input-voucher-redemption .error-validation").css("display", "block");
									$("#enrich-input-voucher-redemption .error-validation").addClass('mandatory-text');
									$('body').animate({
										'scrollTop': 100
									}, 500, function() {});
								}
							});

							break;
						}else{
							bcommon.preloaderClose();
							$("#enrich-voucher-redemption").removeClass("hideclass");	
							$("#enrich-voucher-checking-screen").addClass("hideclass");
							window.location.reload();
							break;	
						}
					}
				}

				// custom validation here
				// pass in validation instance and validation summary objects
				// for use in callback
				// if (typeof onSuccess === 'function') {
				// 	onSuccess(validation, formData, htmlFormData);
				// }
			}
		});

		displayErrorSummaryAtFormTop();

		/**
		 * Consolidate error messages and display at the top of the form
		 */
		function displayErrorSummaryAtFormTop() {
	        // When there's a click on a error message from the div
	        form.on('click', 'a[class^="focus-"]', function(){
	        	// take the field's name from the class
				let nameVal:string         = $(this).attr('class').replace(/focus-/g,'');
				let mabHeaderHeight:number = $('#mab-header').outerHeight();
				let errorField:any         = form.find("#" + nameVal);
				let errorFieldPos:number   = 0;

	        	if (isSelectize(errorField)) {
	        		// is selectize element
	        		errorFieldPos = errorField.next().offset().top - mabHeaderHeight - $(window).scrollTop() - errorField.next().outerHeight();
	        	} else {
	        		// every other input field
		        	errorFieldPos = errorField.offset().top - mabHeaderHeight - $(window).scrollTop();
	        	}

	        	// scroll to error element
	        	$("html, body").animate({ scrollTop: errorFieldPos });

	        	// focus on the element after scrolling to it
	        	// - if selectize, click on input field to trigger dropdown open
	        	if (isSelectize(errorField)) {
		        	errorField.next().find('.selectize-input').click();
	        	} else {
		        	errorField.focus();
	        	}
	        });

			if (!document.body.getAttribute('data-form-validate-init')) {
	        	document.body.setAttribute('data-form-validate-init', '1');
				// Before each validation, clear the error-validation of the div
		        _window.Parsley.on('form:validate', function(_form:any) {

		        	// get scoped validation summary div
		        	// scoped for pages with multiple forms
					let validationSummary:any = _form.$element.find('.error-validation');

		            validationSummary.html('');
		            validationSummary.hide();
		        });
			}

			if (!document.body.getAttribute('data-field-error-init')) {
	        	document.body.setAttribute('data-field-error-init', '1');
		        // When a field has an error
		        _window.Parsley.on('field:error', function(fieldInstance:any){

		        	// get scoped validation summary div
		        	// scoped for pages with multiple forms
					let validationSummary:any = fieldInstance.parent.$element.find('.error-validation');

		            // Get the error messages
		            // var messages = _window.ParsleyUI.getErrorsMessages(fieldInstance);
		            var messages = fieldInstance.getErrorsMessages();

		            // Get the field's name
		            var fieldId = fieldInstance.$element.attr('id');
					var fieldNameRaw = fieldInstance.$element.attr('name');
					var fieldName    = fieldNameRaw.replace(/--/g, ' ');
					fieldName        = fieldName.replace(/-/g, ' ');

		            // Loop through all the messages
		            for (var i in messages) {

						if(fieldId==="update-profile--personal-address-state" && messages[i]==="This value seems to be invalid.")
						{
							messages[i]= "This value should be alphabets only.";
						}
		                // Create a message for each error
		                var $m = $('<p id="error--'+fieldId+'"><a class="focus-' + fieldId + '" href="#">' + '<span class="field-name">' + fieldName + ': </span>' + messages[i] + '</a><p>');

		                let fieldIdExists:any = validationSummary.find('#error--'+fieldId);

		                // Append the errors to the div if not shown
		                if (fieldIdExists.length) {
		                	fieldIdExists.remove();
			                validationSummary.append($m);
		                } else {
			                validationSummary.append($m);
		                }
		            }

		        	validationSummary.show();
		        });
		    }
		}

		/**
		 * test if field is selectize input
		 * @param {any} el [jquery object - input element to test]
		 * @return boolean
		 */
		function isSelectize(el:any) {
        	if (el.prop('type') == 'select-one' && el.hasClass('selectized')) {
        		return true;
        	} else {
        		return false;
        	}
		}
	}
	/**
	 * Custom Parsley Validator - Exact length of field
	 * - field length == requirement
	 */
	customValidationExactLength():void {
		// check if validation has already been set

		let $body = $('body');

		if ($body.attr('data-validation-exact-length') !== undefined ) {
			console.log('exactLength validator has been previously defined');
		} else {
			let domWindow:any = window;
			domWindow.Parsley.addValidator('exactLength', {
			    requirementType: 'string',
			    validateString: function(value:any, requirement:any) {
			      return 0 === value.length % requirement;
			    },
			    messages: {
			      en: 'This requires %s digits.'
			    }
			  });

			$body.attr('data-validation-exact-length', true);
		}
	}


	/**
	 * Custom Parsley Validator - Password field
	 * - min 6 chars
	 * - max 12 chars
	 * - alphanumeric only
	 * - at least 1 letter/integer
	 */
	customValidationPasswordAlphanum():void {
		// check if validation has already been set

		let $body = $('body');

		if ($body.attr('data-validation-mh-password-alphanum') !== undefined ) {
			console.log('mhPasswordAlphanum validator has been previously defined');
		} else {
			let domWindow:any = window;
			domWindow.Parsley.addValidator('mhPasswordAlphanum', {
			    requirementType: 'boolean',
			    validateString: function(value:any, requirement:any) {
			    	let pwPattern = /^[A-Za-z0-9\d\s]+$/;
			    	let regexTest:boolean;
			    	regexTest = pwPattern.test(value);
			      return regexTest;
			    },
			    messages: {
			      en: 'This value can contain only alphanumeric characters.'
			    }
			  });

			$body.attr('data-validation-mh-password-alphanum', true);
		}
	}

	/**
	 * Custom Parsley Validator - Password field
	 * - min 6 chars
	 * - max 12 chars
	 * - alphanumeric only
	 * - at least 1 letter/integer
	 */
	customValidationPasswordMinAlpha():void {
		// check if validation has already been set

		let $body = $('body');

		if ($body.attr('data-validation-mh-password-min-alpha') !== undefined ) {
			console.log('mhPasswordMinAlpha validator has been previously defined');
		} else {
			let domWindow:any = window;
			domWindow.Parsley.addValidator('mhPasswordMinAlpha', {
			    requirementType: 'boolean',
			    validateString: function(value:any, requirement:any) {
			    	let alphaPattern = /[A-z]/;
			    	let numPattern = /[0-9]/;

			    	let alphaTest:boolean;
			    	let numTest:boolean;

			    	alphaTest = alphaPattern.test(value);
			    	numTest = numPattern.test(value);
			      return alphaTest && numTest;
			    },
			    messages: {
			      en: 'This value must contain at least one letter and one number.'
			    }
			  });

			$body.attr('data-validation-mh-password-min-alpha', true);
		}
	}

	redirectUser(msg:string): void {
		// if (msg.indexOf("timeout") > -1) {
		// 	msg = msg.replace("timeout-","");
		// 	window.location.href = msg;
		// }
	}

	initMemberRegistered(): void {
		$(document).ready(function() {
			let registerMsg:any 			= $(".register-success-message");
			let registerContainer:any = $(".registersuccessnew").parent();

			if (registerMsg.length) {
				registerContainer.removeClass("page-wrapper");

				var value 			= "; " + document.cookie;
				var parts 			= value.split("; " + "tempCard" + "=");
				var cookieValue = "{}";

				if (parts.length == 2) {
					cookieValue = parts.pop().split(";").shift();
				}

				let userinfo:any 			= JSON.parse(cookieValue);
				let name:string 			= userinfo.name;
				let flyerId:string 		= userinfo.flyerId;
				let expiryDate:string = userinfo.cardExpiryDate;

				// populate user details into card component
				$(".card--username").text(name);
				$(".card--number").text("MH" + flyerId);
				// $(".card--expiry").text(expiryDate);
				$("#member-mhnumber").text(flyerId);
				// set class only if other classes are not present
				if (!(
					$('body').hasClass('member--platinum') ||
					$('body').hasClass('member--gold') ||
					$('body').hasClass('member--silver')
					)) {
					console.log('body has no other class');
						$('body').addClass("member--blue");
				}
			}
		});
	}
	getCookie(name:string): any {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		var cookieVal:any;
		if (parts.length == 2) {
			cookieVal = parts.pop().split(";").shift();
			return cookieVal;
		}
	}
	isGOMcard():any{
		let _self = this;
		let parts1 =_self.getCookie("phantom");
		if(parts1) {
			var isGOMCard=JSON.parse(parts1).isGOMCard; ;
			var enrichTier=JSON.parse(parts1).memberStatus ;
			if(isGOMCard != "" && isGOMCard!=undefined && isGOMCard == "true")
			{
				$(".background-card").addClass('enrich-gomuser');
				$(".background-card .card--gomuser").removeClass('hide');
				if(enrichTier.toUpperCase()=='BLUE')
				{
					// $(".background-card img").attr('src', 'https://www.malaysiaairlines.com/content/dam/mas/enrich/new-header-menu/Enrich_Card_Blue_GOM.png')
					$(".background-card img").attr('src', 'https://malaysiaairlines.com/content/dam/mas/mobile_app/blue_gom.png')
				}
				else if(enrichTier.toUpperCase()=='SILVER')
				{
					// $(".background-card img").attr('src', 'https://www.malaysiaairlines.com/content/dam/mas/enrich/new-header-menu/Enrich_Card_Silver_GOM.png')
					$(".background-card img").attr('src', 'https://malaysiaairlines.com/content/dam/mas/mobile_app/silver_gom.png')
				}
				else if(enrichTier.toUpperCase()=='GOLD')
				{
					// $(".background-card img").attr('src', 'https://www.malaysiaairlines.com/content/dam/mas/enrich/new-header-menu/Enrich_Card_Gold_GOM.png')
					$(".background-card img").attr('src', 'https://malaysiaairlines.com/content/dam/mas/mobile_app/gold_gom.png')
				}
				else if(enrichTier.toUpperCase()=='PLATINUM')
				{
					// $(".background-card img").attr('src', 'https://www.malaysiaairlines.com/content/dam/mas/enrich/new-header-menu/Enrich_Card_Plat_GOM.png')
					$(".background-card img").attr('src', 'https://malaysiaairlines.com/content/dam/mas/mobile_app/platinum_gom.png')
				}
			}
	}
}
	getProfileCookie(cookieName: any) {
		let cookies:any  = [];
		document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookies.push({key: key.trim(), value : value});
		});
		let ck = cookies.filter((c: any) => {
			return cookieName === c.key;
		})
		return ck;
	}
}

try {
	let memberportal = new memberPortal();
	memberportal.getParameterByName().done((result: any) => {
		if(result === "OK")
		{
			memberportal.setMemberContainerMinHeight();
			memberportal.mobileNavbarClickHandler();
			memberportal.mobileNavInit();
			memberportal.stringifyMemberNavMilesValue();
			memberportal.initMemberRegistered();
			memberportal.handleNavbarCollapse();
			memberportal.isGOMcard();
		}
		else{
			window.location.href = "http://localhost:5000/deals.html";
		}
		
	});

} catch(e) {console.error(e);}
